import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Determine if we're on the home page
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Our Brands', path: '/brands' },
  { name: 'Retail', path: '/retail' },
  { name: 'Media', path: '/media' },
  { name: 'Contact', path: '/contact' }];


  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ?
      'bg-black/95 backdrop-blur-md shadow-lg' :
      isHomePage ?
      'bg-transparent' :
      'bg-white shadow-md'}`
      }>

      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo - White on home page, Black on other pages */}
          <Link to="/" className="flex items-center space-x-3">
            <img
              src={isHomePage ? "/images/amar-stars-logo-white.png" : "/images/amar-stars-logo-black-new.png"}
              alt="Amar Stars LLC"
              className="h-12 w-auto transition-transform duration-300 hover:scale-100" />

            <span className={`text-xl font-semibold tracking-tight hidden sm:block uppercase ${
            isHomePage ? 'text-white' : 'text-black'}`
            } style={{ fontWeight: 600 }}>
              AMAR STARS
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link px-5 py-2 text-sm font-medium transition-colors duration-300 rounded-full ${
              location.pathname === link.path ?
              isHomePage ?
              'text-white bg-white/10' :
              'text-black bg-black/10' :
              isHomePage ?
              'text-gray-300 hover:text-white hover:bg-white/5' :
              'text-gray-700 hover:text-black hover:bg-black/5'}`
              }>

                {link.name}
              </Link>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 hover:bg-opacity-10 rounded-lg transition-colors ${
            isHomePage ? 'text-white hover:bg-white' : 'text-black hover:bg-black'}`
            }
            aria-label="Toggle menu">

            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen &&
        <nav className={`lg:hidden py-6 border-t ${
        isHomePage ? 'border-white/10' : 'border-black/10'}`
        }>
            <div className="flex flex-col space-y-2">
              {navLinks.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsMobileMenuOpen(false)}
              className={`px-4 py-3 text-base font-medium transition-colors duration-300 rounded-lg ${
              location.pathname === link.path ?
              isHomePage ?
              'text-white bg-white/10' :
              'text-black bg-black/10' :
              isHomePage ?
              'text-gray-300 hover:text-white hover:bg-white/5' :
              'text-gray-700 hover:text-black hover:bg-black/5'}`
              }>

                  {link.name}
                </Link>
            )}
            </div>
          </nav>
        }
      </div>
    </header>);

};

export default Header;